/*
 * Miss Kay's — gift note.
 *
 * NOT on the critical path. The fields carry form="<cart form id>", so a native
 * cart-form submit (the Checkout button) already posts them with the order.
 * This element only mirrors the values into the cart via /cart/update.js so they
 * survive a shopper navigating away and coming back, and keeps the cart-page and
 * cart-drawer copies of the block in agreement.
 *
 * That split matters: because persistence at checkout is native, a shopper who
 * types a note and immediately clicks Checkout cannot outrun a debounce and lose
 * it — the failure mode Dawn's own cart-note has.
 */
if (!customElements.get('mk-gift-note')) {
  customElements.define(
    'mk-gift-note',
    class MkGiftNote extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gift-toggle]');
        this.panel = this.querySelector('[data-gift-panel]');
        this.message = this.querySelector('[data-gift-message]');
        this.from = this.querySelector('[data-gift-from]');
        this.counter = this.querySelector('[data-gift-count]');
        if (!this.toggle || !this.panel || !this.message || !this.from) return;

        this.applyState(false);
        this.renderCount();

        this.toggle.addEventListener('change', () => {
          this.applyState(true);
          this.save();
        });
        this.message.addEventListener('input', () => {
          this.renderCount();
          this.queueSave();
        });
        this.from.addEventListener('input', () => this.queueSave());
      }

      /* Disabled fields do not submit, which is exactly how unticking the box
         clears the attributes — only the always-empty hidden inputs post. */
      applyState(userInitiated) {
        const on = this.toggle.checked;
        this.panel.hidden = !on;
        this.message.disabled = !on;
        this.from.disabled = !on;
        if (!on) {
          this.message.value = '';
          this.from.value = '';
          this.renderCount();
        } else if (userInitiated) {
          this.message.focus();
        }
      }

      renderCount() {
        if (this.counter) this.counter.textContent = String(this.message.value.length);
      }

      queueSave() {
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.save(), 500);
      }

      save() {
        clearTimeout(this._timer);
        const on = this.toggle.checked;
        const attributes = {
          Gift: on ? 'Yes' : '',
          'Gift note': on ? this.message.value.trim() : '',
          'Gift from': on ? this.from.value.trim() : '',
        };

        if (typeof fetchConfig !== 'function' || !window.routes || !window.routes.cart_update_url) return;

        return fetch(window.routes.cart_update_url, {
          ...fetchConfig(),
          ...{ body: JSON.stringify({ attributes: attributes }) },
        })
          .then((r) => r.json())
          .then(() => this.broadcast(attributes))
          /* Silent: the native form post is the source of truth at checkout, so a
             failed mirror costs persistence across navigation, never the order. */
          .catch(() => {});
      }

      /* The drawer exists in the DOM on every page, so two copies of this block
         can be mounted at once. Keep them from disagreeing. */
      broadcast(attributes) {
        document.querySelectorAll('mk-gift-note').forEach((el) => {
          if (el !== this && typeof el.adopt === 'function') el.adopt(attributes);
        });
      }

      adopt(attributes) {
        if (!this.toggle) return;
        this.toggle.checked = attributes.Gift === 'Yes';
        this.message.value = attributes['Gift note'] || '';
        this.from.value = attributes['Gift from'] || '';
        this.applyState(false);
        this.renderCount();
      }
    }
  );
}
